import React from 'react';

function App() {
  const value = '';
  return <div>{value}</div>;
}

export default App;
